import type { CustomCellRendererProps } from '@cmg/data-grid';
import { traitListNameSelector } from '@cmg/e2e-selectors';
import React from 'react';
import { Link } from 'react-router-dom';

import routeFactory from '../../../../../../../common/util/routeFactory';
import type { AccountTrait, TraitListColDef } from '../../TraitList.model';

const NameRenderer: React.FC<CustomCellRendererProps<AccountTrait>> = ({ data }) => {
  if (!data) {
    return null;
  }
  return (
    <Link
      to={routeFactory.adminTraitDetail.getUrlPath({ traitCode: data.code })}
      data-testid={traitListNameSelector.testId}
    >
      {data.name}
    </Link>
  );
};

const nameColDef: TraitListColDef = {
  field: 'name',
  headerName: 'Trait',
  cellRenderer: NameRenderer,
  initialSort: 'asc',
  initialWidth: 250,
};

export default nameColDef;
